import * as fromDatatype from '../datatype-library/index';

export interface app_message_store_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  trigger_key: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  local_login_guid: fromDatatype.GuidDataFieldInterface;
  local_message_time: fromDatatype.TimestampTzDatatypeInterface;
  local_created_time: fromDatatype.TimestampTzDatatypeInterface;
  local_updated_time: fromDatatype.TimestampTzDatatypeInterface;
  local_deleted_time: fromDatatype.TimestampTzDatatypeInterface;
  local_status: fromDatatype.StatusDataFieldInterface;
  local_document_id: fromDatatype.VarcharDatatypeInterface;
  local_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_device_id: fromDatatype.VarcharDatatypeInterface;
  remote_user_guid: fromDatatype.GuidDataFieldInterface;
  remote_user_id: fromDatatype.VarcharDatatypeInterface;
  remote_message_guid: fromDatatype.GuidDataFieldInterface;
  remote_created_time: fromDatatype.TimestampTzDatatypeInterface;
  remote_document_id: fromDatatype.VarcharDatatypeInterface;
  document_json: fromDatatype.JsonDatatypeInterface;
  document_byte: any;   //data type is byte[]
  remarks: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  remote_user_profile_json: fromDatatype.JsonDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  local_device_url: fromDatatype.VarcharDatatypeInterface;
  remote_device_url: fromDatatype.VarcharDatatypeInterface;
  reference_number: fromDatatype.VarcharDatatypeInterface;
  remote_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_table_name: fromDatatype.VarcharDatatypeInterface;
  local_table_name: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_message_store_RowClass implements app_message_store_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  trigger_key: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  local_login_guid: fromDatatype.GuidDataFieldInterface;
  local_message_time: fromDatatype.TimestampTzDatatypeInterface;
  local_created_time: fromDatatype.TimestampTzDatatypeInterface;
  local_updated_time: fromDatatype.TimestampTzDatatypeInterface;
  local_deleted_time: fromDatatype.TimestampTzDatatypeInterface;
  local_status: fromDatatype.StatusDataFieldInterface;
  local_document_id: fromDatatype.VarcharDatatypeInterface;
  local_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_device_id: fromDatatype.VarcharDatatypeInterface;
  remote_user_guid: fromDatatype.GuidDataFieldInterface;
  remote_user_id: fromDatatype.VarcharDatatypeInterface;
  remote_message_guid: fromDatatype.GuidDataFieldInterface;
  remote_created_time: fromDatatype.TimestampTzDatatypeInterface;
  remote_document_id: fromDatatype.VarcharDatatypeInterface;
  document_json: fromDatatype.JsonDatatypeInterface;
  document_byte: any;   //data type is byte[]
  remarks: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  remote_user_profile_json: fromDatatype.JsonDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  local_device_url: fromDatatype.VarcharDatatypeInterface;
  remote_device_url: fromDatatype.VarcharDatatypeInterface;
  reference_number: fromDatatype.VarcharDatatypeInterface;
  remote_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_table_name: fromDatatype.VarcharDatatypeInterface;
  local_table_name: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


